module.exports = __webpack_public_path__ + "static/media/checkbox.9dd65a51.svg";